import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface PolicyMenuState {
    tabIndex: number;
}

interface SetPolicyMenuState {
    setPolicyMenuState: (values: Partial<PolicyMenuState>) => void;
    resetPolicyMenu: () => void;
}

const initialState: PolicyMenuState = {
    tabIndex: -1,
};

const storeProps = { name: "policy-store" } as const;

export const usePolicyMenuStore = create<PolicyMenuState & SetPolicyMenuState>()(
    devtools(
        persist(
            set => ({
                ...initialState,
                setPolicyMenuState: set,
                resetPolicyMenu: () => set(initialState),
            }),
            storeProps
        ),
        storeProps
    )
);
